import RadioInputGroup from './RadioInputGroup';
export default RadioInputGroup;